import pl from "@locales/educational_materials/pl.json";
import en from "@locales/educational_materials/en.json";

export default {
  pl,
  en,
};
